/* eslint-disable react-hooks/exhaustive-deps */
import { Stack } from '@mui/material';
import { Fragment, useEffect } from 'react';
import Question from '../../Question/Question';
import { changeCurrentErrorMessage, changeIsButtonEnabled } from '../../../redux/actions';
import { useDispatch } from 'react-redux';
import '../ParcoursEmprunteur.scss';


const questions = [
    <Fragment>
        <p style={{ fontSize: 16 }}>
            Par volonté de vous offrir la meilleure expérience client possible, un conseiller Julia va vous appeler pour valider votre contrat.
            <br /><br />Merci de votre confiance 😀
        </p>
    </Fragment>
];


export default function SignatureEmprunteur() {
    const dispatch = useDispatch();

    useEffect(() => {
        window.scroll(0, 0);
        dispatch(changeIsButtonEnabled(true));
        return () => {
            dispatch(changeCurrentErrorMessage(null));
            dispatch(changeIsButtonEnabled(false));
        }
    }, []);

    return (
        <Stack alignItems={"center"} justifyContent={"center"} mt={10}>
            <h3>Nous avons bien enregistré votre dossier.</h3>
            <Question question={questions[0]} />
        </Stack>
    )
};